import deleteWithToken from './base/delete-with-token'

const customerDeleteTimelineItem = (id) => deleteWithToken(`/customer-timeline/${id}`)()

export default customerDeleteTimelineItem